import { AuthenticationService } from './../authentication.service';
import { AppSettingService } from './../../services/app-setting.service';
import { CustomLoadingService } from './../../shared/custom-loading/custom-loading.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup; // our model driven form


  public returnUrl: string;
  error: any;
  error1: boolean = false;
  timeouts: any;
  menuerror: boolean = false;
  errorMessage: any
  constructor(
    private formBuilder: FormBuilder,
    private loadingService: CustomLoadingService,
    private settingService: AppSettingService,
    private authService: AuthenticationService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.activatedRoute
      .data

      .subscribe(className => {

        document.getElementById('body').className = className["activeClass"];
      });
    this.loginForm = this.formBuilder.group({
      UserName: ['', Validators.compose([Validators.required])],
      Password: ['', Validators.compose([Validators.required])],
      RememberMe: [''],
    });

    this.translate.onLangChange.subscribe(res => {
     if(this.error)
      this.errorMessage = this.translate.instant(this.error);

    })
  }
  login(model: any, isValid: boolean) {
    if (isValid) {
      this.loadingService.show();
      //  this.toastService.activate("hi");

      model.grant_type = "password";
      model.Password = encodeURI(model.Password)
      this.authService.login(model)
        .subscribe(response => {
          if (response && response.access_token) {
         
            this.settingService.loggedInUser = response;
            if (JSON.parse(this.settingService.loggedInUser.Menus).MainMenus.length > 0) {
              let menus = JSON.parse(this.settingService.loggedInUser.Menus)

              let mainMenus: any = [];
              let moreMenus: any = [];
              mainMenus = menus.MainMenus.filter(m => m.IsCustomMenu == 0)
              moreMenus = menus.MoreMenus.filter(m => m.IsCustomMenu == 0)

              if (mainMenus != undefined && mainMenus.length > 0) {
                this.settingService.landingScreenUrl = mainMenus[0].Link
              } else if (moreMenus != undefined && moreMenus.length > 0) {
                

                this.settingService.landingScreenUrl = moreMenus[0].Link

              }
              else
                this.settingService.landingScreenUrl = "/settings";
            }

            AppSettingService.userLoggedIn.next(response)
          }
          this.loadingService.hide();
        },
          (error) => {

            this.error = true;
            if (error != undefined) {

              if (error.status == 0) {
                this.error ="Common.Error."+ error.error?.error_description;;
                this.errorMessage = this.translate.instant(this.error)
              }
              else if (error.error == 403) {
                this.error ="Common.Error."+ error.error?.error_description;
                this.errorMessage = this.translate.instant(this.error)
              }
              else if (error.status == 400) {
                this.error ="Login."+ error.error?.error_description;
                this.errorMessage = this.translate.instant(this.error)
              }
            }

            this.loadingService.hide();
          },
          () => { this.route.navigate([this.settingService.landingScreenUrl]); }
        );
    }
  }
}
